import { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import { fetchCategoryWinners } from "../../lib/api";
import { SectionHeader } from "./SectionHeader";
import { PickCard } from "./PickCard";

export const CategoryWinners = () => {
  const [winners, setWinners] = useState(null);

  useEffect(() => {
    fetchCategoryWinners().then(setWinners).catch(() => setWinners([]));
  }, []);

  if (winners && winners.length === 0) return null;

  return (
    <section data-testid="home-category-winners" className="mt-12 sm:mt-16">
      <SectionHeader
        icon={Trophy}
        eyebrow="Category winners"
        title="The current AI pick in every aisle"
      />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        {(winners || Array.from({ length: 8 })).map((p, i) =>
          p ? (
            <PickCard key={p.slug || i} pick={p} kicker={`Best in ${p.category_label || p.category}`} />
          ) : (
            <div
              key={i}
              className="h-60 rounded-2xl bg-card border border-border animate-pulse"
            />
          ),
        )}
      </div>
    </section>
  );
};

export default CategoryWinners;
